import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  computed,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSpacer',
  props: {
  size: {
    type: String,
    default: 'm',
  },
},
  setup(__props) {

const props = __props;

const spacerClass = computed(() => {
  switch (props.size) {
    case 's':
      return 'small';
    case 'r':
      return 'regular';
    case 'm':
      return 'medium';
    case 'l':
      return 'large';
    case 'xl':
      return 'extra-large';
    default:
      return props.size;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spacer", `spacer-${spacerClass.value}`])
  }, null, 2))
}
}

})